<template>
  <div>
    <modal
      class="output_options-modal"
      width="600px"
      height="330px"
      :backdrop="false"
      :value="showModal"
      effect="fade"
      @closed="closed"
      large
    >
      <!-- custom header -->
      <div slot="modal-header" class="modal-header" style="padding-left:25px;">
        <h4 class="modal-title">
          <strong>選択中　{{qtyToReject}}件</strong>
        </h4>
      </div>
      <div
        class="modal-body output_options-modal-body"
        style="height: 120px;padding: 0px 15px; overflow-x: auto;"
      >
        <div>
          差戻を行います。<br>
          差戻理由等の記入が可能です。<span style="color:red;">(任意)</span>
        </div>
        <textarea
           rows="3"
          ref="local_value"
          style="margin-top:10px;"
          type="text"
          class="form-control"
          v-on:input="updateValue($event.target.value)"
          id="local_value"
          name="local_value"
          v-bind:value="localValue"
          placeholder
        ></textarea>
      </div>
      <div slot="modal-footer" class="modal-footer" style="background:white">
        <button type="button" class="btn btn-default" @click="closed('no')">戻る</button>
        <button type="button" class="btn btn-danger" @click="closed('yes')">一括差戻</button>
      </div>
    </modal>
  </div>
</template>

<script>
import Vue from "vue";
import { bus } from "@/libs/bus";
import { utils } from "@/libs/utils";
var vm = this;

import modal from "./local-modal";

Vue.component("modal", modal);
import _ from "lodash";
import debug from "debug";
var debug_input_manual = debug("esma:input-modal");

export default {
  data() {
    return {
      show_modal: false,
      title_label: "",
      callback: null,
      local_value: "",
      qty_to_reject:0
    };
  },
  computed: {
    qtyToReject:{
      get(){
        return this.qty_to_reject;
      },
      set(v){
        this.qty_to_reject = v;
      }
    },
    localValue: {
      get() {
        return this.local_value;
      },
      set(v) {
        console.log("showModalWindow Set localValue", v);
        this.local_value = v;
      },
    },

    textTitle() {
      return this.title_label;
    },
    showModal() {
      return this.show_modal;
    },
  },
  methods: {
    updateValue(val) {
      this.localValue = val;
      // this.$emit('inputed', this.localValue);
    },
    onShow() {},
    showModalWindow(data) {
      debug_input_manual("showModalWindow data", data);
      this.onShow();
      this.qtyToReject =  data.qty;
      this.show_modal = true;
      this.$refs.local_value.focus();
      setTimeout(() => {
        this.$refs.local_value.focus();
      }, 100);
    },
    closed(mode) {
      debug_input_manual("mode", mode);
      this.$emit("closed", { mode: mode, value: this.localValue });
      this.show_modal = false;
    },
  },
  props: {
    tag: { type: String, default: "showInputModal" },
    qty: { type: Number },
  },
  mounted() {
    debug_input_manual("On mounted");
    bus.$on(this.$props.tag, this.showModalWindow);
  },
  beforeDestroy() {
    bus.$off(this.$props.tag);
  },
};
</script>
<style scoped>
.info_div {
  width: 32%;
  float: left;
}
.esma_td2 {
  margin: 2px 0px;
  border: 0px solid #bdbdbd;

  font-size: 11px;
  font-weight: 500;
  padding: 4px 0px 4px 4px;
}

.esma_td_h2 {
  margin: 2px 0px;
  _border: 1px solid #bdbdbd;
  _background-color: #b4d5f1;
  padding: 4px 8px;
  font-size: 11px;
  _font-weight: 900;
}
</style>



// WEBPACK FOOTER //
// bulk-reject-modal.vue?367de698